import {Trans} from '@lingui/macro';
import React from 'react';

import {SearchContactsTooltipOptions} from '../../../../../../../src/components/common/dropdowns/search/searchContactsDropdown';

export const accountDetailsContactsDropdownRenderTooltip = ({
  isDisabled,
  contactHandlesJoined,
  account,
}: SearchContactsTooltipOptions) => {
  if (!isDisabled || !account) {
    return contactHandlesJoined;
  }
  return <Trans id="account-details-contacts-contact-disabled">Already added to {account.name}</Trans>;
};
